import { useState,useEffect } from 'react';
import Helper from '../functions/Helper.js';

function getShoeData(shoeID,currentShoe,shoeList){
  if(currentShoe?.shoe_id === shoeID){
    return(currentShoe);
  }
  else{
    return(Helper.getShoeByID(shoeID,shoeList));
  }
}

export const useShoeByID = (shoeID,currentShoe,shoeList,fetchShoe) => {
  const [returnShoe,setReturnShoe]=useState(getShoeData(shoeID,currentShoe,shoeList));
  useEffect(()=>{
    setReturnShoe(getShoeData(shoeID,currentShoe,shoeList));
  },[currentShoe,shoeList,shoeID])

  useEffect(()=>{
    if(currentShoe?.shoe_id === shoeID){
      //loading same Shoe again
      if(!currentShoe?.COMPLETE_LOAD){
        Helper.fetchShoeDataByID(shoeID).then((x)=>{
          fetchShoe(x);
        })
      }
    }
    else{
      let tempShoe=Helper.getShoeByID(shoeID,shoeList);
      fetchShoe(tempShoe);
      if(!tempShoe?.COMPLETE_LOAD ?? false){
        Helper.fetchShoeDataByID(shoeID).then((x)=>{
          fetchShoe(x);
        })
      }
    }
  },[]);
  return(returnShoe)
};
